import { BaseComponent } from '../../../components/BaseComponent';
import { HBox } from '../../../components/Box';
import { Copy } from '../../../components/Icon';
import React from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { Button } from '../../../components/Buttons';
import { INVOICE_DIRECTIONS } from '../constants';
import { VehicleAddToOrderCard } from '../../Vehicles/components/VehicleAddToOrderCard';
import { InvoiceCreateCopyModals } from '../pages/createIncomingCopy/AddIncomingInvoiceCopy';
import { Modal } from '../../../components/Modal';

const STATE = {
  showIncomingVehicle: false,
  showModal: false,
  showOutgoingVehicle: false,
  copyProductInvoice: false,
};

class CopyInvoiceModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  reset() {
    this.setState({ ...STATE });
  }

  onOpenModal() {
    if (this.props.direction === INVOICE_DIRECTIONS.OUTGOING && this.props.subjectType === 'vehicle') {
      this.setState({
        showOutgoingVehicle: true,
        showModal: true,
      });
    }
    if (this.props.direction === INVOICE_DIRECTIONS.INCOMING && this.props.subjectType === 'vehicle') {
      this.setState({
        showIncomingVehicle: true,
        showModal: true,
      });
    }
    if (this.props.direction && this.props.subjectType === 'product') {
      this.setState({
        copyProductInvoice: true,
        showModal: true,
      });
    }
  }

  renderModal() {
    return (
      <Modal onClose={() => this.reset()}>
        {this.state.showIncomingVehicle && (
          <InvoiceCreateCopyModals copyFromInvoiceId={this.props.copyFromInvoiceId} vehicleId={this.props.vehicleId} />
        )}
        {this.state.showOutgoingVehicle && (
          <VehicleAddToOrderCard vehicleId={this.props.vehicleId} copyFromInvoiceId={this.props.copyFromInvoiceId} />
        )}
        {this.state.copyProductInvoice && (
          <Button
            disabled={this.invoice?.type !== INVOICE_TYPES.INVOICE || !this.invoice?.exportedAt}
            onClick={this.tofn(`/invoices/product/${this.props.direction}/create-copy/${this.props.copyFromInvoiceId}`)}
            primary
          >
            {this.lbl('invoice.details.copy_invoice')}
          </Button>
        )}
      </Modal>
    );
  }

  render() {
    if (!this.props.copyFromInvoiceId) return <></>;
    return (
      <HBox key={this.props.copyFromInvoiceId}>
        {this.state.showModal && this.renderModal()}

        <div
          onClick={evt => {
            evt.stopPropagation();
            this.onOpenModal();
          }}
          style={{ cursor: 'pointer', width: '30px', color: '#11ab79' }}
        >
          <Copy />
        </div>
      </HBox>
    );
  }
}

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CopyInvoiceModal = compose(withConnect, withRouter)(CopyInvoiceModalComp);
